<div class="flex flex-col gap-1">

  <label class="kt-form-label font-medium text-xs mb-1">

    {{ field.label }}

  </label>

  <textarea
    rows="3"
    class="kt-input kt-input-sm h-auto min-h-[4rem] resize-y"
    [placeholder]="field.placeholder || ''"
    [formControl]="control">

  </textarea>

  <mat-error *ngIf="isInvalid">

    {{ getError() }}

  </mat-error>

</div>

